// 内容数据
import request from '@/utils/request'

// 获取数据中心语言列表

export const dataCenterIos = () =>
  request({
    url: '/dataCenter/ios_lang',
    method: 'get'
  })

export const dataCenterAndroid = () =>
  request({
    url: '/dataCenter/android_lang',
    method: 'get'
  })

export const dataCenterBanner = () =>
  request({
    url: '/dataCenter/banner_lang',
    method: 'get'
  })

export const dataCenterSpecial = () =>
  request({
    url: '/dataCenter/special_lang',
    method: 'get'
  })

// 内容数据统计列表
export const getContentList = (data: any) =>
  request({
    url: '/data/contentList',
    method: 'get',
    params: data
  })

// 内容数据统计列表
export const getBannerData = (data: any) =>
  request({
    url: '/dataCenter/banner',
    method: 'get',
    params: data
  })

// 专题数据统计列表
export const getSpecialData = (data: any) =>
  request({
    url: '/dataCenter/special',
    method: 'get',
    params: data
  })
